import Business from './Business.jsx';
import BusinessContentContainer from './BusinessContentContainer.jsx';
import BusinessPageHeader from './BusinessPageHeader.jsx';


export {Business, BusinessContentContainer, BusinessPageHeader}
export default Business;



// WEBPACK FOOTER //
// ./components/business/business-page/index.js